import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";

interface GoalSubCategoryFormProps {
  validation: any;
  isEdit?: boolean;
  categories?: any[];
}
const statusOptions = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];
const GoalSubCategoryForm: React.FC<GoalSubCategoryFormProps> = ({
  validation,
  isEdit = false,
  categories = [],
}) => {
  // Category order options (1-100)
  const categoryOrderOptions = Array.from({ length: 100 }, (_, i) => ({
    label: String(i + 1),
    value: i + 1,
  }));

  const activeCategories = React.useMemo(() => {
    if (!Array.isArray(categories)) return [];
    const active = categories.filter((category: any) => 
      category.status?.toLowerCase() === "active"
    );
    
    if (isEdit && validation.values.parent_id) {
      const currentCategory = categories.find(
        (cat: any) => cat.id === validation.values.parent_id
      );
      if (currentCategory && !active.find((cat: any) => cat.id === currentCategory.id)) {
        active.push(currentCategory);
      }
    }
    
    return active;
  }, [categories, isEdit, validation.values.parent_id]);

  return (
    <Row className="g-3">
      <Col md={12}>
        <Label className="fw-bold mb-1">
          Category Name <span className="text-danger">*</span>
        </Label>
        <Input
          type="select"
          name="parent_id"
          value={validation.values.parent_id || ""}
          onChange={validation.handleChange}
          invalid={
            !!(validation.submitCount > 0 && validation.errors.parent_id)
          }
          disabled={isEdit}
          style={isEdit ? { background: "#f1f1f1", cursor: "not-allowed" } : {}}
        >
          <option value="">Select category</option>
          {activeCategories.map((category: any) => (
            <option key={category.id} value={category.id}>
              {category.category_name}
            </option>
          ))}
        </Input>
        {validation.submitCount > 0 && validation.errors.parent_id && (
          <FormFeedback>{validation.errors.parent_id}</FormFeedback>
        )}
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Sub Category Name <span className="text-danger">*</span>
        </Label>
        <div className="position-relative">
          <Input
            type="text"
            name="category_name"
            placeholder="Enter sub category name"
            value={validation.values.category_name || ""}
            onChange={(e) => {
              let text = e.target.value;
              text = text.replace(/[^a-zA-Z _-]/g, "");
              if (text.length > 70) {
                text = text.substring(0, 70);
              }
              validation.setFieldValue("category_name", text);
            }}
            style={{ paddingRight: "60px" }}
            invalid={
              !!(validation.submitCount > 0 && validation.errors.category_name)
            }
          />
          {validation.submitCount > 0 && validation.errors.category_name && (
            <FormFeedback>{validation.errors.category_name}</FormFeedback>
          )}
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "12px",
              transform: "translateY(-50%)",
              fontSize: "12px",
              color: "#6c757d",
              pointerEvents: "none",
            }}
          >
            {(validation.values.category_name || "").length}/70
          </div>
        </div>
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Sub Category Order <span className="text-danger">*</span>
        </Label>
        <Select
          options={categoryOrderOptions}
          name="category_order"
          placeholder="Select category order"
          value={categoryOrderOptions.find((opt) => opt.value === validation.values.category_order) || null}
          onChange={(e: { value: any }) => validation.setFieldValue("category_order", e?.value)}
          classNamePrefix="react-select"
          className={validation.submitCount > 0 && validation.errors.category_order ? "react-select-error" : ""}
        />
        {validation.submitCount > 0 && validation.errors.category_order && (
          <div className="invalid-feedback d-block">{validation.errors.category_order}</div>
        )}
      </Col>

      {isEdit && (
        <Col md={12}>
          <Label className="fw-bold mb-1">
            Status <span className="text-danger">*</span>
          </Label>
          <div style={{ width: "200px" }}>
            <Select
              options={statusOptions}
              name="status"
              placeholder="Select status"
              value={statusOptions.find((opt) => opt.value === validation.values.status) || null}
              onChange={(e: { value: any }) => validation.setFieldValue("status", e?.value)}
              onBlur={() => validation.setFieldTouched("status", true)}
              classNamePrefix="react-select"
              className={validation.touched.status && validation.errors.status ? "react-select-error" : ""}
            />
          </div>
          {validation.touched.status && validation.errors.status && (
            <div className="invalid-feedback d-block">{validation.errors.status}</div>
          )}
        </Col>
      )}
    </Row>
  );
};

export default GoalSubCategoryForm;
